// import { logEvent } from '@firebase/analytics';
import { addDoc, collection, serverTimestamp } from '@firebase/firestore';
import { useCallback, useRef } from 'react';

// import useAnalytics from './useAnalytics';
import useFirestore from './useFirestore';
// import useIp from '../contexts/ip/useIp'

const eventTypes = {
  impression: 'view_content',
  click: 'select_content',
}

const useTracker = (type, once) => {
  // const { ip, isLoaded } = useIp()
  // const analytics = useAnalytics()
  const firestore = useFirestore()
  const tracked = useRef(false)
  // const queue = useRef()

  return useCallback((profileId, blockId, itemId, linkId) => {
    if (process.env.NODE_ENV !== 'production' || !profileId || tracked.current) return true
    if (firestore) {
      if (once) tracked.current = true
      const event = {
        content_type: 'block_item',
        block_id: blockId,
        profile_id: profileId,
      }
      if (itemId) event.content_id = itemId
      if (linkId) event.link_id = linkId
      try {
        window.gtag('event', eventTypes[type], event)
      } catch (e) {
        console.error(e)
      }

      const dbLog = {
        blockId,
        // userAgent: navigator.userAgent,
        timestamp: serverTimestamp(),
      }
      if (itemId) dbLog.itemId = itemId
      if (linkId) dbLog.linkId = linkId
      try {
        addDoc(collection(firestore, 'profiles', profileId, `${type}s`), dbLog)
      } catch (e) {
        console.error(e)
      }
      return true
    }
  }, [type, firestore, once])
}

export default useTracker;
